import React, { useEffect, useState, useRef, useMemo, useCallback } from "react"
import { Link, useLocation, useNavigate } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import TableContainer from "./projectRFQListContainer"
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
} from "reactstrap"

import Breadcrumbs from "components/Common/Breadcrumb"
import DeleteModal from "components/Common/DeleteModal"
import { isEmpty } from "lodash"
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"
import Spinners from "components/Common/Spinner"
import { getProjectUnits, getProposals } from "store/actions"
import { getAllRfq } from "helpers/fakebackend_helper"
import { getStatusBadgeClassOfMainRFQ } from "components/Common/handleStatusColorOfRFQ"

const ProjectRFQList = () => {
  const [isLoading, setLoading] = useState(false)
  const location = useLocation();
  const navigate = useNavigate(); // Replace useHistory with useNavigate
    
  // Parse pageIndex from URL query parameter or default to 0
  const query = new URLSearchParams(location.search);
  const initialPageIndex = parseInt(query.get('pageIndex')) || 0;

  // Handle page changes
  const handlePageChange = useCallback((newPageIndex) => {
    const newQuery = new URLSearchParams(location.search);
    newQuery.set('pageIndex', newPageIndex);
    navigate({ search: newQuery.toString() }, { replace: true });
    console.log("handlePageChange")
  }, [location.search, navigate]);
  
  document.title = "All RFQ"
  const authUser = JSON.parse(localStorage.getItem("authUser"))
  const dispatch = useDispatch()
  const [permission, setPermission] = useState(
    JSON.parse(localStorage.getItem("permission"))
  )
  
  const changeDateFormat = date => {
    return date?.toString().split("-").reverse().join("-")
  }

  const [rfqList, setRfqList] = useState([])
    useEffect(() => {
      // Define and execute data fetching functions
      const fetchRfqData = async () => {
        try {
          const response = await getAllRfq()
          setRfqList(response.data)
        } catch (error) {
          console.error("Error fetching rfq:", error)
        }
      }
  
      // Call both fetch functions
      fetchRfqData()
    }, [])

  const columns = useMemo(
    () => [
      {
        Header: "#",
        accessor: "srNo",
        sortBy: true,
        Cell: cellProps => {
          return (
            <>
              <h5 className="font-size-14 mb-1"> {cellProps.row.index + 1}</h5>
            </>
          )
        },
      },

      {
        Header: "RFQ Code",
        accessor: "rfq_code",
        filterable: true,
        Cell: cellProps => {
          return (
            <>
              <h5 className="font-size-14 mb-1">
                {cellProps.row.original.rfq_code}
              </h5>
            </>
          )
        },
      },
      {
        Header: "Project",
        accessor: "project_name",
        filterable: true,
        Cell: cellProps => {
          return (
            <>
              <h5 className="font-size-14 mb-1">
                {cellProps.row.original.project_name}
              </h5>
            </>
          )
        },
      },
      {
        Header: "Ticket ID",
        accessor: "ticket_no",
        filterable: true,
        Cell: cellProps => {
          const ticketId = cellProps.row.original.ticket_id
          const ticketNo = cellProps.row.original.ticket_no
          return (
            <>
              {ticketId ? (
                <Link
                  to={`/tickets/view-ticket/${ticketId}`}
                  className="text-primary"
                >
                  <h5 className="font-size-14 mb-1">{ticketNo}</h5>
                </Link>
              ) : (
                <h5 className="font-size-14 mb-1">--</h5>
              )}
            </>
          )
        },
      },
      {
        Header: "RFQ Title",
        accessor: "rfq_title",
        filterable: true,
        Cell: cellProps => {
          return (
            <>
              <h5 className="font-size-14 mb-1">
                {cellProps.row.original.rfq_title}
              </h5>
            </>
          )
        },
      },
      {
        Header: "Created Date",
        accessor: "issue_date",
        filterable: true,
        Cell: cellProps => {
          return (
            <>
              <h5 className="font-size-14 mb-1">
                {cellProps.row.original.issue_date?changeDateFormat(cellProps.row.original.issue_date):"--"}
              </h5>
            </>
          )
        },
      },
      {
        Header: "Expiry Date",
        accessor: "valid_to",
        filterable: true,
        Cell: cellProps => {
          return (
            <>
              <h5 className="font-size-14 mb-1">
                {cellProps.row.original.valid_to}
              </h5>
            </>
          )
        },
      },
      {
        Header: "Good & Service Head",
        accessor: "head_text",
        filterable: true,
        Cell: cellProps => {
          return (
            <>
              <h5 className="font-size-14 mb-1">
                {cellProps.row.original.head_text}
              </h5>
            </>
          )
        },
      },

   
      {
        Header: "Status",
        accessor: "current_status_name",
        filterable: true,
        Cell: cellProps => {
          return (
            <>
              <h5
                className={`badge rounded-pill font-size-11 ${getStatusBadgeClassOfMainRFQ(cellProps.row.original.current_status_id)}`}
                
              >
                {cellProps.row.original.current_status_name}
              </h5>
            </>
          )
        },
      },

      {
        Header: "Action",
        Cell: cellProps => {
          const handleActionChange = event => {
            const selectedAction = event.target.value

            // Perform any necessary actions based on the selected value
            if (selectedAction === "Edit") {
              navigate(
                `/project-management/edit-project-rfq/${cellProps.row.original.id}`
              )
            } else if (selectedAction === "Delete") {
              onClickDelete(cellProps.row.original.billing_id)
            } else if (selectedAction === "Record Payment") {
              navigate(
                `/billing/record-payment/${cellProps.row.original.billing_id}`
              )
            } else if (selectedAction === "Send Email to Customer") {
              sendMailModal(
                cellProps.row.original.billing_id,
                cellProps.row.original.bill_no,
                cellProps.row.original
              )
            } else if (selectedAction === "Send Whatsapp") {
              // Handle Send Whatsapp action
            } else if (selectedAction === "Audit Trail") {
              // Handle Audit Trail action
            } else if (selectedAction === "Download Invoice") {
              handleDownloadInvoice(cellProps.row.original.billing_id)
            } else if (selectedAction === "Send invitations") {
              navigate(`/project-management/invite-rfq-vendors/${cellProps.row.original.id}`)
            } else if (selectedAction === "View RFQ Detail") {
              navigate(`/project-management/view-rfq-quotes/${cellProps.row.original.id}`)
            }
            event.target.value = "Action"
          }
          return (
            <div>
              <select
                className="form-select"
                name="action"
                onChange={handleActionChange}
              >
                <option disabled selected>
                  Action
                </option>
                {permission
                  .filter(
                    item => item.page === "/edit-bill/:id" && item.access === 1
                  )
                  .map((item, index) => (
                    cellProps.row.original.current_status_id === 1 && (
                      <option key={index}>Edit</option>
                    )
                  ))}
                {permission
                  .filter(
                    item => item.page === "delete-rfq" && item.access === 1
                  )
                  .map((item, index) => (
                    <option key={index}>Delete Bill</option>
                  ))}
                  
                {permission
                  .filter(
                    item =>
                      item.page === "/invite-rfq-vendors/:id" &&
                      item.access === 1
                  )
                  .map((item, index) => (
                    cellProps.row.original.is_assigned === 0 && (
                      <option key={index}>Send invitations</option>
                    )
                  ))}
                {permission
                  .filter(
                    item =>
                      item.page === "/view-rfq-quotes/:id" && item.access === 1
                  )
                  .map((item, index) => (
                    <option key={index}>View RFQ Detail</option>
                  ))}
              </select>
            </div>
          )
        },
      },
    ],
    []
  )

  const handleUserClick = arg => {
    const user = arg
  }

  var node = useRef()
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page)
    }
  }

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false)
  const [deleteId, setDeleteId] = useState()

  const onClickDelete = users => {
    setDeleteId({ id: users })
    setDeleteModal(true)
  }

  const handleDeleteUser = () => {
    if (deleteId && deleteId.id) {
      dispatch(deletePendingBills(deleteId.id))
    }
    onPaginationPageChange(1)
    setDeleteModal(false)
    navigate("/pendingBills")
    dispatch(getPendingBillsList())
  }

  const handleUserClicks = () => {
    setUserList("")
    setIsEdit(false)
    toggle()
  }

  const keyField = "id"

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="RFQ List"
            // breadcrumbItem="My Project List"
          />
          <Row className="justify-content-center">
            <Col lg={12}>
              <CardTitle className="h4 mb-3" style={{ fontSize: "20px" }}>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex gap-2">
                    All RFQ List
                  </div>
                  <div className="d-flex gap-2">
                    <Link
                      to="/project-management/rfq-dashboard"
                      className="btn btn-primary btn-sm"
                    >
                      <i className="bx bx-bar-chart-alt-2 me-1"></i>
                      RFQ Dashboard
                    </Link>
                    {/* <Link
                      to="/project-management/add-project-rfq"
                      className="btn btn-success btn-sm"
                    >
                      <i className="bx bx-plus me-1"></i>
                      Add New RFQ
                    </Link> */}
                  </div>
                </div>
              </CardTitle>
            </Col>
          </Row>
         <Row>
            {isLoading ? (
              <Spinners setLoading={setLoading} />
            ) : (
              <Col lg="12">
                <Card>
                  <CardBody>
                    <TableContainer
                      initialPageIndex={initialPageIndex}
                      onPageChange={handlePageChange}
                      isPagination={true}
                      columns={columns}
                      data={rfqList}
                      isGlobalFilter={true}
                      isShowingPageLength={true}
                      isAddUserList={true}
                      iscustomPageSizeOptions={true}
                      handleUserClick={handleUserClicks}
                      customPageSize={10}
                      tableClass="table align-middle table-nowrap table-hover"
                      theadClass="table-light"
                      paginationDiv="col-sm-12 col-md-7"
                      pagination="pagination pagination-rounded justify-content-end mt-4"
                    />
                  </CardBody>
                </Card>
              </Col>
            )}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ProjectRFQList
